import { Directive, effect, ElementRef, inject, input, untracked } from '@angular/core';

@Directive({
	selector: '[autofocusOnInit]',
	standalone: true,
})
export class AutofocusOnInitDirective {
	private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

	public readonly $autofocusOnInit = input<boolean | string>(true, { alias: 'autofocusOnInit' });

	constructor() {
		effect(() => {
			const autofocus = this.$autofocusOnInit();
			untracked(() => {
				if (autofocus === true || autofocus === 'true' || autofocus === '') {
					try {
						this.elementRef.nativeElement.focus();
					} catch (error) {
						console.error(error);
					}
				}
			});
		});
	}
}
